import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  name: "",
  id: null,
};

export const technicianSlice = createSlice({
  name: "technician",
  initialState,
  reducers: {
    setTechnician: (state, action) => {
      state.name = action.payload.name;
      state.id = action.payload.id;
    },
    unsetTechnician: (state, action) => {
      state.name = initialState.name;
      state.id = initialState.id;
    },
  },
});

export const { setTechnician, unsetTechnician } = technicianSlice.actions;

export default technicianSlice.reducer;
